import { Component, OnInit, ViewChild, EventEmitter, Output, ViewChildren, QueryList, HostListener, OnDestroy } from '@angular/core';
import { IssueElement, Issue } from '../../issues.model';
import { IssuesRest } from '../../issues.rest';
import { NgForm, NgModel } from '@angular/forms';
import { ModalComponent } from '../../../core/shared/modal/modal.component';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { DateInputModel } from '../../../core/shared/date-input/date-input.model';
import { ActivatedRoute } from '@angular/router';
import { RichTextComponent } from '../../../core/shared/richtext/richtext.component';
import { Subscription } from 'rxjs';
import { INgxSelectOption } from 'ngx-select-ex';
import { LoginRest } from '../../../login/login.rest';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';

@Component({
  selector: 'app-issue-element-modal',
  templateUrl: './issue-element-modal.component.html',
  styleUrls: ['./issue-element-modal.component.scss']
})
export class IssueElementModalComponent implements OnInit, OnDestroy {

  public states: ObjectToSelect[];
  public employees: ObjectToSelect[];
  public elementCopy: IssueElement;
  private element: IssueElement;
  private isAdding: boolean;
  private createdDate: DateInputModel;
  private issue: Issue;
  private subscription: Subscription;
  private currentUser: any;
  private summerNoteHeight =  500;
  constructor(private route: ActivatedRoute, 
              private rest: IssuesRest, 
              private loginRest: LoginRest,
              private spinnerService: SpinnerService) { this.onResize(); }

  private elementDescriptionView: RichTextComponent = null;

  @Output() onSuccess: EventEmitter<any> = new EventEmitter();
  @ViewChild(ModalComponent) public modal: ModalComponent;
  @ViewChild('elementForm') elementForm: NgForm;
  @ViewChild('employeeId') employee;
  @ViewChildren(RichTextComponent) elementDescriptionViews: QueryList<RichTextComponent>;

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent2(event: KeyboardEvent) {
    if (this.element && !this.element.employeeId && document.activeElement.className.includes('modal')) {
      this.employee.valueAccessor.optionsOpen(event.key);
    }
  }

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.modal.modalRoot.isShown === true) {
      this.save();
      event.preventDefault();
    }
  }

  ngOnInit() {
    this.modal.title = 'Element zgłoszenia';
    this.getStates();
    this.loginRest.GetLoggedUser().subscribe((user: any) => {
      this.currentUser = user;
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  @HostListener('window:resize', ['$event'])
  private onResize(event?) {
    if (window.innerWidth <= 767){
      this.summerNoteHeight = 250;
    } else {
      this.summerNoteHeight = 500;
    }
  }

  public getStates() {
    const action = this.rest.getStates;
    action.call(this.rest).subscribe((result: ObjectToSelect[]) => {
        if (result) {
            this.states = result;
        }
    });
  }

  public getCustomerEmployees(customerId: number) {
    const action = this.rest.getCustomerEmployees;
    action.call(this.rest, customerId).subscribe((result: ObjectToSelect[]) => {
        if (result) {
            this.employees = result;
        }
    });
  }

  public closeModal() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.spinnerService.hide();
    this.modal.close();
  }

  public setModel(element: IssueElement, isAdding: boolean, assigneeName: string, issue: Issue) {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.isAdding = isAdding;
    this.issue = issue;
    if (isAdding) {
      element.objectStateId = this.states[0].id;
      element.assignedTo = assigneeName;
      element.issueId = this.issue.id;
      element.createdBy = this.currentUser.email;
      element.createdDate = new Date();
      if (!element.employeeId) {
        element.employeeId = this.currentUser.employeeId;
      }
    }
    this.elementCopy = element;
    this.element = this.elementCopy;
    this.modal.openWithCustomSize({'maxwidth': '1500px'});
    this.initializeDate();
    this.getDescription();
    this.getCustomerEmployees(this.issue.customerId);
  }

  private save() {
    this.spinnerService.show();
    if (this.element.isNew === true) {
      this.saveDescription();
      this.element.employeeFullName = this.employees.find(x => x.id === this.element.employeeId).name.split(' (')[0];
      this.element.stateTranslation = this.states.find(x => x.id === this.element.objectStateId).name;
      const emmitData = {isSuccess: true, element: this.element, isNew: this.isAdding};
      if (this.issue.id.toString() !== '0') {
        if (!this.element.id) {
          this.element.id = 0;
        } else {
          this.element.isNew = false;
        }
        this.rest.saveElement(this.element, this.element.isNew).subscribe((element: IssueElement) => {
          this.element.id = element.id;
          this.element.isNew = true;
          this.closeModal();
          this.onSuccess.emit(emmitData);
        });
      } else {
        this.element.id = (this.issue.issueElements.length !== 0 ? (-1) * Math.min.apply(Math, this.issue.issueElements.map(function (o) { return o.id; })) : 0);
        this.closeModal();
        this.onSuccess.emit(emmitData);
      }
    } else {
      this.closeModal();
    }
  }

  private initializeDate() {
    this.createdDate = new DateInputModel();
    this.createdDate.isReadOnly = true;
    this.createdDate.isRequired = false;
    this.createdDate.name = 'Data';
    this.createdDate.value = new Date(this.element.createdDate);
    this.createdDate.valueStr = this.createdDate.value.toDateString();
    this.createdDate.withTime = false;
    this.createdDate.dateFormat = 'dd.MM.yyyy HH:mm';
  }

  private getDescription() {
    if (this.elementDescriptionView) {
      if (this.element.isNew === false) {
        this.elementDescriptionView.disableContol();
        this.elementDescriptionView.setHtml(this.element.htmlDescripiton);
      } else {
        this.elementDescriptionView.enableContol();
        if (this.isAdding) {
          this.elementDescriptionView.setHtml('');
        } else {
          this.elementDescriptionView.setHtml(this.element.htmlDescripiton);
        }
      }
    } else {
      this.subscription = this.elementDescriptionViews.changes.subscribe((nv: QueryList<RichTextComponent>) => {
        if (this.elementDescriptionView === null) {
          this.elementDescriptionView = nv.first;
        }

        if (this.elementDescriptionView && this.isAdding) {
          this.elementDescriptionView.setHtml('');
          this.element.htmlDescripiton = '';
        } else {
          this.elementDescriptionView.setHtml(this.element.htmlDescripiton);
        }

        if (this.element.isNew === false) {
          this.elementDescriptionView.disableContol();
        } else {
          this.elementDescriptionView.enableContol();
        }
      });
    }
  }

  private saveDescription() {
    const description = this.elementDescriptionView.getHtml();
    if (this.elementDescriptionView.isEmpty(description)) {
      this.element.htmlDescripiton = '';
    } else {
      this.element.htmlDescripiton = description;
    }
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }

  private stateChanges(event: any) {
    if (!this.element.isNew || (this.element.stateTranslation && this.element.stateTranslation.localeCompare(event[0].text) === 0)) {
      return;
    }

    if (event[0].text.localeCompare('Oczekiwanie na odpowiedź') === 0) {
      this.element.isInternal = false;
      this.element.employeeId = this.issue.reporterId;
    } else if (event[0].text.localeCompare('Odpowiedź') === 0) {
      this.element.employeeId = this.issue.assigneeId;
    } else if (event[0].text.localeCompare('Do realizacji') === 0 || event[0].text.localeCompare('Zakończony') === 0) {
      this.element.employeeId = this.currentUser.employeeId;
    }
  }
}
